export enum BoxShadow {
    S = '2px 2px 10px rgba(0, 0, 0, .1)',
    M = '4px 4px 20px rgba(0, 0, 0, .1)',
    L = '6px 6px 40px rgba(0, 0, 0, .1)',
}
